var Payment = xClass("OppoQuickgamePayment")
Payment.prototype.ctor = function () {

}

/**
 * oppo接口错误码转义
 * @param {Number} errCode 错误码
 * @returns {String} 错误信息的中文描述
 * @see https://developers.weixin.qq.com/miniprogram/document/midas-payment/requestMidasPayment.html?t=201812
 * @todo 修改为从strings配置中读取
 */
Payment.prototype.errCodeToMsg = function (errCode) {
    if (typeof errCode == "string") {
        errCode = parseInt(errCode)
    }
    let msg = null;
    switch (errCode) {
        case 100001:
            msg = "账号异常";
            break;
        case 200500:
            msg = "小游戏支付服务-系统异常";
            break;
        case 200400:
            msg = "小游戏支付服务-请求错误"
            break;
        case 201005:
            msg = "小游戏支付服务-账号已过期"
            break;
        case 200404:
            msg = "小游戏支付服务-数据不存在";
            break;
        case 200501:
            msg = "小游戏支付服务-参数错误";
            break;
        case 200502:
            msg = "小游戏支付服务-签名错误";
            break;
        case 301002:
            msg = "订单号重复";
            break;
        case 301003:
            msg = "超过最大限额";
            break;
        case 301004:
            msg = "取消支付";
            break;
        case 310040:
            msg = "支付app 需要安装或者更新";
            break;
        case 301005:
            msg = "结果未知";
            break;
        case 301007:
            msg = "版本无更新";
            break;
        case 301010:
            msg = "支付失败";
            break;
        case 301012:
            msg = "正在处理中";
            break;
        case 301100:
            msg = "正在处理中";
            break;
        case 301200:
            msg = "签名错误";
            break;
        case 301201:
            msg = "缺少参数";
            break;
        case 302000:
            msg = "支付宝免密签约状态查询结果:已签约";
            break;
        case 302001:
            msg = "支付宝免密签约状态查询结果:未签约";
            break;
        case 302002:
            msg = "支付宝免密签约状态查询结果:未知";
            break;
        case 302003:
            msg = "对应应用没有开通免费权限";
            break;
        case 302004:
            msg = "签约成功，支付失败";
            break;
        case 305000:
            msg = "余额错误";
            break;
        case 305001:
            msg = "系统错误";
            break;
        case 305002:
            msg = "余额不足";
            break;
        case 305003:
            msg = "参数异常";
            break;
        case 305004:
            msg = "用户不存在";
            break;
        case 305005:
            msg = "登录鉴权失败";
            break;
        case 305006:
            msg = "商户订单号重复";
            break;
        case 305555:
            msg = "支付失败";
            break;
        case 330000:
            msg = "余额查询成功";
        break;
        case 330001:
            msg = "余额查询失败";
        break;
        case 330002:
            msg = "余额查询未知";
        break;
        case 500000:
            msg = "支付插件异常";
            break;
        default:
            msg = null;
            break;
    }
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == 301004){
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[####]call oppo pay id:"+data.productId)
    let productId = data.productId

    function onSuccess(resp) {
        let data = resp.data
        console.log("[################]getinfohttp success")
        let orderId = data.orderId;
        let balance = data.balance
        let cash = data.cash
        //data.paySign//后端生成的签名的时间戳
        console.log("[#############]oppo pay data "+ JSON.stringify(data))
        if (!balance || balance < cash) {
            // 余额不足，充值
            let payment = {
                appId:30098064,
                token:META.tokenid,
                timestamp:data.timestamp,
                orderNo:data.orderNo,
                paySign:data.paySign,
                success: function() {
                    successCallback && successCallback({orderId});
                },
                fail: function (res) {
                    console.log("[######]fail res:"+JSON.stringify(res))
                    let fail_type = self.getFailType(res.code);
                    failCallback({
                        code: res.code,
                        data: res.data,
                        msg: self.errCodeToMsg(res.code),
                        type: fail_type,//1代表是第三方掉起支付失败
                    })
                }
            }
            cc.log("oppo pay", JSON.stringify(payment))
            mini.pay(payment)
        } 
        else 
        {
            // 余额够，不需要充值，直接购买
            //pay()
        }
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = OppoQuickgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId:productId,
        openid: META.tokenid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        engineVersion:META.platformVersion,
        ext: data.ext
    })
    console.log("[####]oppo pay:"+META.platformVersion)
}

module.exports = Payment